import { Controller } from '@hotwired/stimulus';

/*
Conecta los eventos de expandir y contraer los filtro. Ñapa temporal hasta que cambiemos
los filtros y usemos algo más genérico
*/
/* global connectFiltersWrapper */
export default class extends Controller {
  connect() {
    connectFiltersWrapper(this.element, { forzar: true });
  }
}
